var _path, _path2, _path3, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderTransportDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89471 4.62964L2.89471 4.52154C2.89471 3.41697 3.79014 2.52154 4.89471 2.52154L10.6603 2.52154C11.0804 2.52154 11.421 2.18093 11.421 1.76077V1.76077C11.421 1.34061 11.7616 1 12.1818 1L17 1C18.1045 1 19 1.89543 19 3L19 13C19 14.1046 18.1045 15 17 15L10.9473 15",
    stroke: "#2A2D34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57941 14.9993L16.5969 14.9993C17.8469 14.9993 18.7906 13.8654 18.5636 12.6361L17.3873 6.26574C17.2122 5.31727 16.3851 4.62891 15.4206 4.62891L3.40311 4.62891C2.15308 4.62891 1.20938 5.76282 1.43636 6.99207L2.61266 13.3624C2.78779 14.3109 3.6149 14.9993 4.57941 14.9993Z",
    stroke: "#2A2D34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0037 12C11.0037 13 10.877 14 10.0037 14C9.13048 14 9.00372 13 9.00372 12C9.00372 11 6.08563 10.6882 6.00374 10C5.88473 8.99982 8.63696 8.5 10.0038 8.5C11.3706 8.5 14.1175 9.04374 14.0037 10C13.9391 10.5432 11.0037 11 11.0037 12Z",
    fill: "#2A2D34"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 3.7,
    stroke: "#2A2D34",
    strokeWidth: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9.5,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#00A651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTransportDark);
export default __webpack_public_path__ + "static/media/folder_transport_dark.18653b3f7cda102498bf7250fd78fd2b.svg";
export { ForwardRef as ReactComponent };